import { setScatter, formatRegions, setGeo, setLines } from "../tools";
import china from '../json/china.json';
import * as echarts from 'echarts';
import './index.css';

export default {
  name: 'BeMap',
  props: {
    id: { type: String, default: () => (`b-e-map-${Math.random().toString().substring(2)}`) },
    resizeCondition: { type: Array, default: () => ['width'] },
    theme: { type: String, default: () => 'macarons' },
    delay: { type: Number, default: () => 800 },
    area: { type: String, default: () => '' },
    site: { type: String, default: () => '' },
    data: { type: Array, default: () => [] },
    zoom: { type: Number | String, default: () => 1.2 },
    width: { type: String, default: () => '100%' },
    height: { type: String, default: () => '80vh' },
    config: { type: Object, default: () => ({}) },
    adCode: { type: String, default: () => '430100' },
    background: { type: String, default: () => '#07a1fe' },
    acticeBackground: { type: String, default: () => 'red' },
    enableScale: { type: Boolean, default: () => true },
    delay: { type: Number, default: () => 1000 },
  },
  data() {
    return {
      scale: this.zoom,
      charts: null,
      option: null,
      regions: null,
    }
  },
  watch: {
    area: {
      deep: true,
      handler() {
        this.create();
      }
    },
    $route() {
      this.create();
    }
  },
  mounted() {
    let timeout = null;
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    } else {
      timeout = setTimeout(() => {
        this.create();
        clearTimeout(timeout);
        timeout = null;
      }, this.delay);
    }
  },
  beforeDestroy() {
    this.cancel();
  },
  methods: {
    create() {
      let area = this.area != '' ? JSON.parse(this.area) : china;
      if (area) {
        this.cancel();
        echarts.registerMap(this.id, area);
        this.regions = formatRegions(area, this.background);
        let charts = echarts.getInstanceByDom(this.$el);
        if (charts) echarts.dispose(charts);
        this.charts = echarts.init(this.$el, this.theme);
        this.option = {
          geo: setGeo(this.id, this.regions),
          grid: {
            containLabel: this.enableScale, // 图形缩放
          },
          tooltip: {
            trigger: 'item',
            formatter: '{b}: {c}',
          },
          series: [
            ...setLines(this.regions, this.adCode),
            ...setScatter(this.regions, this.adCode),
          ],
          ...this.config,
        };
        this.charts.clear();
        this.charts.setOption(this.option, true);
        let timeout = null;
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        } else {
          timeout = setTimeout(() => {
            addEventListener('resize', () => this.charts && this.charts.resize());
            addEventListener('transitionend', a => this.charts && this.resize(a));
            clearTimeout(timeout);
            timeout = null;
          }, this.delay);
        }
        if (this.regions && this.regions.length > 0) {
          this.charts.off('click');
          this.charts.on('click', region => {
            let area = region.region || region.data || null;
            this.regions.forEach(a => {
              a.selected = false;
              if (area && (a.id == area.id)) a.selected = !area.selected;
            });
            this.select(area);
          });
          this.charts.off('georoam');
          this.charts.on('georoam', ({ zoom }) => zoom && (this.scale = Number((this.scale * zoom.toFixed(1)).toFixed(1))));
          (this.option && this.option.geo && this.option.geo.zoom) ? this.option.geo.zoom = this.scale : () => null;
        }
      }
    },
    resize({ propertyName }) {
      this.resizeCondition.includes(propertyName) && this.charts.resize();
    },
    select(a) {
      this.$emit('select', a && !a.selected && a);
    },
    cancel() {
      if (this.charts) {
        removeEventListener('transitionend', this.charts.resize);
        removeEventListener('resize', this.resize);
        this.$nextTick(() => {
          echarts.dispose(this.charts);
          this.charts.dispose();
          this.charts.clear();
          this.option = null;
          this.charts = null;
        });
      }
    },
  },
  render() {
    return (<div id={this.id} key={this.id} class="b-e-map" style={{ width: this.width, height: this.height }} />);
  }
}